var React = require('react');

function HeplChatIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.85","d":"M12 0V4H0V24H2.41L6.41 20H20V16H25.58L29.58 20H32V0H12ZM18 18H5.58L2 21.58V6H18V18ZM30 17.58L26.41 14H20V4H14V2H30V17.58Z","fill":"#2A97B7"}));
}

HeplChatIcon.defaultProps = {"width":"32","height":"24","viewBox":"0 0 32 24","fill":"none"};

module.exports = HeplChatIcon;

HeplChatIcon.default = HeplChatIcon;
